
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"195","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Vector Smart Object copy 16","width":"195","height":"120","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMMAAAB4CAYAAABPckYcAAAC6ElEQVR4nO3dMWiVVxjH4f/NpQ6l0KWli4tQnSw4FBytGbrp1E26FrN1M+DkFqR0NIPQKRldAh1KIYO0Q6CLCELBoUM2QXBoh4AoH+eEYGjOl03J+zxwyZr75v3B/b57c+4ydUzPdSvJpSR/FHre8I4phO0kb/pj3Xio6HgIgqCkk0I4fHxjLahgLoQNW0AFQgAhQDMXws/mRAVzIWwmWdgEzjohgBCgEQIIARohgBCgEQIIARohgBCgEQIIARohgBCgEQL0Jf9FCFS36MsuBEoTAggBGiGAEKARAggBGiGAEKARAggBGiGAEKARAggBGiGAEKARAggBGiGAEKARAggBmrkQtoVABacJYWkTOOuEAEKARgggBGiEAEKARgiUdvgm2fTzQZLbJwzj7yS/9SjgTFqcIgQo4fClkRAobyXJQfUhQPoF8XQt8EWSrz+A3wfem9NeQP+V5E9/JqqYgng4uLW6YROoZO5LyQVBKXNB3LUOVDIXxLptoJKPkuwIAppzM0H8aE5UMhfEmm2gkimI3wUBzcdJdgdB/GBOVDIK4nWSW7aBSqYgHgsCmk+T7AkCmrkgbpoTlYyCOBAE1XyW5KkgoPl8JohvzYlKRkH8l2TVNlDJFMRzQUBzfiaIa+ZEJaMgXiW5ahuoZAriH0FA82WSfUFAMwriZZKvzIlKRkG8EATVXO6LLwjoCz8K4qIhUckoiP3+kgrKuNLvJgkC+m3VURAXDIlKRkE872/cQRlTEP8KAprV/iE+QcBMEM/6x8OhjFEQTwVBNTf6v4oKAvohAicF8aSfygFljILYEwTVfNcPJBME9KMqR0F8YkhUMgpitx+GDGV8f0IMgqCkNUHAkVEQv/av3IIyRkHsCIJq7ggCjqwPgniUZGlWVDIKYlsQVHNPEHBkYxDEVpKFWVHJKIhNQVDNT4KAZtGXXhBwiiDuGxKVzAVx3TZQyUq/tXo8hHVbQEXLY0EIgdIOgxAC/y/JW1vUIm65gXYoAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    